const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');

const SellerForm = require('app/seller/Form');

class InfoTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'seller': {'id':null,'name':null},
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.seller = this.settings.seller;

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }

    onDOMReady(){
        this.sellerForm.onDOMReady();
    }

    buildTab(){
        this.$container
        .html('')
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-12 p-2')
                .append(this.buildInfosForm())
            )
        );

        this.onDOMReady();
    }

    buildInfosForm(){
        var self = this;
        this.sellerForm = new SellerForm({
            'seller': this.seller,
            'success': function(){
                self.sellerForm.refresh();
            }
        });

        return this.sellerForm.getForm();
    }
}

module.exports = InfoTab;

